<template>
   <div>
      <NavbarComponent />
      <main class="profile-page">
         <section
            class="relative pt-16 pb-32 flex content-center items-center justify-center min-header"
         >
            <div
               class="absolute top-0 w-full h-full bg-center bg-cover"
               :style="{
                  backgroundImage: `url(${headerImage})`,
               }"
            >
               <span
                  id="blackOverlay"
                  class="w-full h-full absolute opacity-75 bg-black"
               ></span>
            </div>
            <div class="container relative mx-auto">
               <div class="items-center flex flex-wrap">
                  <div
                     class="w-full lg:w-12/12 px-4 ml-auto mr-auto text-center"
                  >
                     <div class="pr-10">
                        <h1 class="text-white font-semibold text-5xl mb-6">
                           Frac Support
                        </h1>
                        <p class="mt-4 text-lg text-blueGray-200">
                           We can help you with any questions you have on our
                           products, services, or anything else.
                        </p>
                        <!-- Support Features: flowing flex row, always colored, inside banner, with 20px gap -->
                        <div
                           class="w-full px-4 mt-10 flex flex-wrap justify-center"
                           style="gap: 20px 40px"
                        >
                           <div
                              v-for="item in supportItems"
                              :key="item.label"
                              class="flex flex-col items-center mb-4"
                           >
                              <i
                                 :class="
                                    'fas ' +
                                    item.icon +
                                    ' fa-2x mb-2 support-icon'
                                 "
                                 :style="{ color: item.color }"
                              ></i>
                              <span class="font-semibold text-white">{{
                                 item.label
                              }}</span>
                           </div>
                        </div>
                        <!-- Contact Form Button below icons -->
                        <div class="w-full flex justify-center mt-6">
                           <button
                              @click="scrollToContact"
                              class="bg-emerald-600 text-white font-bold rounded px-6 py-3 shadow hover:bg-emerald-700 transition-colors duration-150"
                           >
                              Contact Our Support Team
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section class="relative py-16 bg-blueGray-200">
            <div class="container mx-auto px-4">
               <div
                  class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg"
               >
                  <div class="px-6 py-10 text-center">
                     <h2 class="text-4xl font-bold text-blueGray-700 mb-2">
                        Frac Support
                     </h2>
                     <div class="flex justify-center mb-4">
                        <span
                           class="inline-block w-24 h-1 rounded bg-emerald-400"
                        ></span>
                     </div>
                     <p class="text-lg text-blueGray-600 mb-8">
                        Our team of skilled technicians has in-depth knowledge
                        of our products and their applications. We're here to
                        assist with any support inquiries, system
                        configurations, or upgrades required to integrate our
                        products with your equipment.
                     </p>
                  </div>
               </div>
            </div>
         </section>
      </main>
      <FooterComponent />
   </div>
</template>

<script>
import NavbarComponent from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import headerImage from "@/assets/img/industrial-engineer-programming-machine-control.jpg";

export default {
   name: "FracSupport",
   components: {
      NavbarComponent,
      FooterComponent,
   },
   data() {
      return {
         headerImage,
         supportItems: [
            { label: "Upgrades", icon: "fa-arrow-up", color: "#10b981" },
            { label: "Configuration", icon: "fa-cogs", color: "#3b82f6" },
            {
               label: "Equipment Questions",
               icon: "fa-question-circle",
               color: "#f59e42",
            },
            { label: "Hardware Support", icon: "fa-tools", color: "#ef4444" },
            {
               label: "Troubleshooting",
               icon: "fa-life-ring",
               color: "#6366f1",
            },
            {
               label: "Remote Assistance",
               icon: "fa-headset",
               color: "#ec4899",
            },
            {
               label: "Training",
               icon: "fa-chalkboard-teacher",
               color: "#22c55e",
            },
            { label: "Documentation", icon: "fa-book", color: "#3b82f6" },
         ],
      };
   },
   methods: {
      scrollToContact() {
         this.$router.push({ path: "/landing" }).then(() => {
            this.$nextTick(() => {
               const contactSection = document.getElementById("contact");
               if (contactSection) {
                  contactSection.scrollIntoView({ behavior: "smooth" });
               }
            });
         });
      },
   },
};
</script>

<style>
.min-header {
   min-height: 45vh;
}
</style> 